module.exports = __webpack_public_path__ + "img/bg-symptom3.b38e6259.png";